import React from 'react'
import { Footer } from './Footer1'
import Nav from './Nav';

const Login = () => {
  return (
    <div>
<Nav/>

<div class="Login-container">
  <h1 style={{textAlign:'center'}}>Login In</h1>
        <div class="form-container">

          <div id='login-image'>

            <img  src="/asset/login-image.webp" alt="ball"/>
            </div>


            <div id='input-wrapper'>

         
            <div>
                <input type="text" id="input" name="user" placeholder='Username'/>
               
            </div>


            <div>
                <input type="password" id="input" name="user" placeholder='Password'/>
                
            </div>
            
            
            <button id='login-btn'> Login</button>

            <div id='login-with-google'>
              <img style={{width:'40px'}} src='/asset/download (2).png'/>
              <p>Sign in with google</p>
            </div>
        </div>
       

    </div>
    </div>
      <Footer/>
    </div>
  )
}

export default Login